import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux"; // ✅ نضيف دي
import { addToCart } from "../../features/cart/cartSlice"; // ✅ نضيف دي
import "swiper/css";
import "./TopProducts.css";
import products from "../../data/Products.json";

function TopProducts({
  wishlist,
  onAddToWishlist,
  onRemoveFromWishlist,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch(); // ✅ نجهزه

  // ❤️ المفضلة
  const toggleFavorite = (product) => {
    const isFav = wishlist.some((item) => item.id === product.id);

    if (isFav) {
      onRemoveFromWishlist(product.id);
      Swal.fire({
        icon: "info",
        title: "Removed from Wishlist ❤️",
        text: `${product.name} has been removed from your wishlist.`,
        showConfirmButton: false,
        timer: 2000,
      });
    } else {
      onAddToWishlist(product);
      Swal.fire({
        icon: "success",
        title: "Added to Wishlist ❤️",
        text: `${product.name} has been added to your wishlist.`,
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  // 🛒 إضافة للسلة (باستخدام Redux بدل localStorage)
  const handleAddToCart = (product) => {
    dispatch(addToCart(product)); // ✅ ده كل المطلوب

    Swal.fire({
      icon: "success",
      title: "Added to Cart 🛒",
      text: `${product.name} has been added to your cart.`,
      showConfirmButton: false,
      timer: 2000,
    });
  };

  return (
    <section className="top-products gray-bg container-fluid px-md-5 py-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="section-title">Top Products</h2>
        <button
          className="btn btn-outline-primary"
          onClick={() => navigate("/products")}
        >
          View All
        </button>
      </div>

      <Swiper
        modules={[Autoplay]}
        spaceBetween={30}
        slidesPerView={4}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        breakpoints={{
          0: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
        }}
      >
        {products.map((product) => (
          <SwiperSlide key={product.id}>
            <div className="product-card">
              <div className="product-image">
                <img src={product.image} alt={product.name} />
                <div className="product-icons">
                  {/* 👁️ عرض التفاصيل */}
                  <span
                    className="d-flex align-items-center justify-content-center"
                    onClick={() => navigate(`/product/${product.id}`)}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="fas fa-eye"></i>
                  </span>

                  {/* ❤️ المفضلة */}
                  <span
                    className="d-flex align-items-center justify-content-center"
                    onClick={() => toggleFavorite(product)}
                    style={{ cursor: "pointer" }}
                  >
                    <i
                      className={`fas fa-heart ${
                        wishlist.some((item) => item.id === product.id)
                          ? "text-danger"
                          : ""
                      }`}
                    ></i>
                  </span>

                  {/* 🛒 الكارت */}
                  <span
                    className="d-flex align-items-center justify-content-center"
                    onClick={() => handleAddToCart(product)}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="fas fa-shopping-cart"></i>
                  </span>
                </div>
              </div>
              <div className="product-info p-3">
                <h5 className="product-name">{product.name}</h5>
                <p className="product-desc">{product.desc}</p>
                <p className="product-price">${product.price}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default TopProducts;
